angular.module("vgresiduos").controller("CollectionRequestListCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes`, getQueries());
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.coleta) {
				queries.push({ key: "id", value: $stateParams.coleta });
			}
			if ($stateParams.tipo) {
				queries.push({ key: "type", value: $stateParams.tipo });
			}
			return queries;
		}
	}
]);
